import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import Rating from "./Rating";
import Progress from "./Progress";
import { CourseResource } from "../../../../../stores/CoursesStore/Types";
import PreviewImage from "../Course/PreviewImage";
import CourseBadge from "../CourseBadge";

interface Props {
  courseResource: CourseResource;
  userIsInUk: boolean;
  isSample?: boolean;
}

const CourseBody: React.FC<Props> = ({
  courseResource,
  userIsInUk,
  isSample,
}) => {
  const isLocked =
    courseResource.subscription_only && !courseResource.has_subscription;

  return (
    <>
      {/* THUMB */}
      <div className="thumb">
        {isLocked && (
          <div className="overlay">
            <div className="overlay-text">
              <i className="lock icon"></i>
              <span>Subscriber Only</span>
            </div>
          </div>
        )}
        <div className="course-status">
          <CourseBadge courseResource={courseResource} />
        </div>

        <PreviewImage courseResource={courseResource} userIsInUk={userIsInUk} />
      </div>

      {/* INFO */}
      <div className="info">
        <h3>{courseResource.name}</h3>

        <p className="byline">{courseResource.preview_mini_description}</p>

        {/* FOOTER */}
        {courseResource.enrolled_student_present ? (
          <div className="footer-row">
            <div className="progress-circle">
              <PieChart
                data={[
                  {
                    value: courseResource.enrolment_percent_completion,
                    color: "#0D99FF",
                  },
                  {
                    value: 100 - courseResource.enrolment_percent_completion,
                    color: "#dbdee4",
                  },
                ]}
                totalValue={100}
                lineWidth={20}
                startAngle={270}
                label={() => `${courseResource.enrolment_percent_completion}%`}
                labelStyle={{
                  fontSize: "22px",
                  fill: "#392D40",
                }}
              />
            </div>

            <button className="more-info">
              {courseResource.enrolment_percent_completion === 100
                ? "View Again"
                : "Continue"}
            </button>
          </div>
        ) : (
          <div className="footer-row">
            {isSample ? (
              <div className="link">Enrol free →</div>
            ) : (
              <Rating courseResource={courseResource} />
            )}

            {!isSample && (
              <a href={`/courses/${courseResource.slug}`} className="more-info">
                More Info
              </a>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default CourseBody;
